const UserTableHeaderColumns = [
  { id: "fullName", label: "FullName" },
  { id: "email", label: "Email" },
  { id: "phoneNumber", label: "PhoneNumber" },
];
export const MasterUserTableHeaderColumns = [
  { id: "fullName", label: "FullName" },
  { id: "email", label: "Email" },
  { id: "phoneNumber", label: "PhoneNumber" },
  { id: "clinicName", label: "ClinicName" },
  { id: "numberOfPets", label: "NumberOfPets" },
  { id: "activeAppointments", label: "ActiveAppointments" },
  { id: "appointments", label: "Appointments" },
  { id: "createdAt", label: "AccountCreatedAt" },
];
const TABLE_CELL_ALIGNMENT = "center";

export const fiels = ["fullName", "email", "phoneNumber"];
export const masterFields = [
  "fullName",
  "email",
  "phoneNumber",
  "clinicName",
  "numberOfPets",
  "activeAppointments",
  "appointments",
  "createdAt",
];

export const ClinicUserTableHeaderColumns = [
  { id: "fullName", label: "FullName" },
  { id: "email", label: "Email" },
  { id: "phoneNumber", label: "PhoneNumber" },
  { id: "activeAppointments", label: "ActiveAppointments" },
  { id: "appointments", label: "Appointments" },
];
export const clinicUserTableFields = [
  "fullName",
  "email",
  "phoneNumber",
  "activeAppointments",
  "appointments",
];

export { UserTableHeaderColumns, TABLE_CELL_ALIGNMENT };
